<div class="toast-wrapper toast-wrapper-{{position}}" #toastWrapper>
    <div (click)="onClick()" class="native-toast native-toast-{{position}} native-toast-{{type}}" #toastEl>

    </div>
</div>
